import $ from 'jquery';
import 'select2/dist/js/select2.full.js';
import 'select2/dist/js/i18n/fr';
import './extension';

const templateOption = function (option, isResult) {
    const $label = $('<span>', {class: 'select2-label'});

    if (isResult && option.resultLabel) {
        $label.html(option.resultLabel);
    } else if (option.label) {
        $label.html(option.label);
    } else {
        $label.text(option.text);
    }

    return $label;
};

$.fn.select2.defaults.set("theme", "bootstrap-5");
$.fn.select2.defaults.set('language', 'fr');
$.fn.select2.defaults.set('width', '100%');
$.fn.select2.defaults.set('allowClear', true);
$.fn.select2.defaults.set('templateResult', option => templateOption(option, true));
$.fn.select2.defaults.set('templateSelection', option => templateOption(option));

/*
 * Run the jQuery select2 method on all select.select2 elements within a container.
 */
$.fn.select2Container = function () {
    $.fn.select2.apply(this.find('select.select2'), arguments);
};

/*
 * Initialize components when document is ready.
 */
$(function () {
    $(document).select2Container();
});
